"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _avlComponents = require("@availabs/avl-components");

var _Container = _interopRequireDefault(require("./components/Container"));

var _Modal = require("./components/Modal");

var _amsPostMessage = _interopRequireDefault(require("./ams-post-message"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MessagesHeading = function MessagesHeading(_ref) {
  var showModal = _ref.showModal,
      props = _objectWithoutProperties(_ref, ["showModal"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-3xl font-bold"
  }, "Messages"), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-base flex-0"
  }, /*#__PURE__*/_react["default"].createElement(_avlComponents.Button, {
    onClick: showModal
  }, "compose")));
};

var AmsMessages = function AmsMessages(props) {
  var messages = props.messages,
      toggleSelected = props.toggleSelected,
      viewMessages = props.viewMessages,
      viewSelected = props.viewSelected,
      deleteMessages = props.deleteMessages,
      deleteSelected = props.deleteSelected,
      toggleAll = props.toggleAll,
      selected = props.selected;

  var _useModal = (0, _Modal.useModal)(),
      _useModal2 = _slicedToArray(_useModal, 3),
      modalState = _useModal2[0],
      showModal = _useModal2[1],
      closeModal = _useModal2[2];

  var Title = _react["default"].useMemo(function () {
    return /*#__PURE__*/_react["default"].createElement(MessagesHeading, {
      showModal: showModal
    });
  }, [showModal]);

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Modal.Modal, modalState, /*#__PURE__*/_react["default"].createElement("div", {
    className: "bg-gray-200 p-4 rounded"
  }, /*#__PURE__*/_react["default"].createElement(_amsPostMessage["default"], {
    onPostMessage: closeModal
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "col-span-2"
  }, /*#__PURE__*/_react["default"].createElement(_Container["default"], {
    className: "w-full",
    Title: Title
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "grid grid-cols-1 gap-y-1"
  }, !messages.length ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center h-6 px-2"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-4 mr-1 flex-0"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "cursor-pointer",
    type: "checkbox",
    checked: Boolean(selected.length),
    onChange: toggleAll,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  })), !selected.length ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-trash mx-2 cursor-pointer hover:text-red-400",
    onClick: deleteSelected
  }), /*#__PURE__*/_react["default"].createElement("span", {
    className: "fa fa-eye mx-2 cursor-pointer hover:text-blue-400",
    onClick: viewSelected
  }))), messages.sort(function (a, b) {
    return new Date(b.sent_at) - new Date(a.sent_at);
  }).map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement(Message, _extends({
      key: msg.id
    }, msg, {
      deleteMessages: deleteMessages,
      viewMessages: viewMessages,
      toggleSelected: toggleSelected,
      selected: selected.includes(msg.id)
    }));
  })))));
};

var amsMessagesConfig = {
  type: AmsMessages,
  wrappers: ["ams-messages"]
};
var _default = amsMessagesConfig;
exports["default"] = _default;

var Message = function Message(props) {
  var id = props.id,
      heading = props.heading,
      message = props.message,
      sent_by = props.sent_by,
      sent_at = props.sent_at,
      viewed = props.viewed,
      viewMessages = props.viewMessages,
      toggleSelected = props.toggleSelected,
      selected = props.selected;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var toggle = _react["default"].useCallback(function (e) {
    setOpen(!open);

    if (!open && !viewed) {
      viewMessages([id]);
    }
  }, [id, viewMessages, viewed, open]);

  var setChecked = _react["default"].useCallback(function (e) {
    e.stopPropagation();
    toggleSelected(id);
  }, [toggleSelected, id]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    onClick: toggle,
    className: "\n        cursor-pointer px-2 rounded\n        ".concat(viewed ? "bg-gray-300" : "bg-gray-100", "\n      ")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex items-center"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "w-4 mr-1 flex-0"
  }, /*#__PURE__*/_react["default"].createElement("input", {
    className: "cursor-pointer",
    type: "checkbox",
    checked: selected,
    onChange: setChecked,
    onClick: function onClick(e) {
      return e.stopPropagation();
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-lg flex-0 w-72 overflow-hidden mr-4"
  }, sent_by), /*#__PURE__*/_react["default"].createElement("div", {
    className: "font-bold text-lg flex-0"
  }, heading), /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1 text-right"
  }, new Date(sent_at).toLocaleString())), !open ? null : /*#__PURE__*/_react["default"].createElement(_avlComponents.MarkdownViewer, {
    markdown: message
  }));
};